import React from 'react';
import styled from 'styled-components';
import { Stars } from '@catalogo/theme-stars';

const RatingDistribution = ({ stateRating, ratingDistribution, onChangeRating, ratingOptions }) => (
  <RatingList>
    {[5, 4, 3, 2, 1].map(item => {
      const getFilter = ratingOptions.find(filter => filter.rating === item);
      const filteredItemWithEventAction = { ...getFilter, eventAction: 'Avaliações -  Tabela de distribuição' };
      const active = stateRating.rating === getFilter.rating;

      return (
        <RatingListItem key={item}>
          <StarsUI rating={item} size={20} />
          <StarsCount active={active} onClick={() => onChangeRating(filteredItemWithEventAction)}>
            {ratingDistribution[`rating${item}`].count}
          </StarsCount>
        </RatingListItem>
      );
    })}
  </RatingList>
);

export default RatingDistribution;

const RatingList = styled.ul``;

const RatingListItem = styled.li`
  display: flex;
  align-items: flex-end;
  text-decoration: underline;
  margin-bottom: 7px;
  align-items: center;
  font-size: 14px;
`;

const StarsUI = styled(Stars)`
  margin-right: 10px;
  background: red;
`;

const StarsCount = styled.button`
  padding: 0;
  border: none;
  outline: none;
  background: none;
  margin-left: 8px;
  color: ${({ active }) => (active ? `#000` : `#666`)};
  ${({ active }) => active && `font-weight: 600`}
`;
